// Product page countdown timer

document.addEventListener('DOMContentLoaded', function () {
  const countdowns = document.querySelectorAll('[data-countdown]');

  if (!countdowns.length) return;

  countdowns.forEach((countdown) => {
    const endDateString = countdown.getAttribute('data-end-date');
    const hideWhenComplete = countdown.getAttribute('data-hide-when-complete') === 'true';
    const expiredMessage = countdown.getAttribute('data-expired-message') || 'Expired';

    const daysEl = countdown.querySelector('[data-days]');
    const hoursEl = countdown.querySelector('[data-hours]');
    const minutesEl = countdown.querySelector('[data-minutes]');
    const secondsEl = countdown.querySelector('[data-seconds]');
    const gridEl = countdown.querySelector('[data-countdown-grid]');
    const expiredEl = countdown.querySelector('[data-countdown-expired]');

    if (!endDateString) return;

    const endDate = new Date(endDateString).getTime();

    if (Number.isNaN(endDate)) {
      console.warn('Invalid countdown date:', endDateString);
      return;
    }

    const pad = (value) => String(value).padStart(2, '0');

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance <= 0) {
        clearInterval(interval);

        if (hideWhenComplete) {
          countdown.style.display = 'none';
          return;
        }

        if (gridEl) gridEl.hidden = true;
        if (expiredEl) {
          expiredEl.hidden = false;
          expiredEl.textContent = expiredMessage;
        }
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const megaMenuItems = document.querySelectorAll(
    '.site-nav--is-megamenu > .site-nav__details'
  );

  megaMenuItems.forEach((details) => {
    let closeTimer = null;

    const summary = details.querySelector(':scope > summary');

    const openMenu = () => {
      clearTimeout(closeTimer);

      megaMenuItems.forEach((otherDetails) => {
        if (otherDetails !== details) {
          otherDetails.removeAttribute('open');

          const otherSummary = otherDetails.querySelector(':scope > summary');
          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });

      details.setAttribute('open', '');

      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    };

    const closeMenu = () => {
      clearTimeout(closeTimer);

      closeTimer = setTimeout(() => {
        details.removeAttribute('open');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }, 250);
    };

    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', closeMenu);
  });
});